<template>
    <Frame name="账号管理" :hasRightBtn="true">
        <Head title="基本信息"></Head>
        <div class="account-content">
            <Row type="flex" justify="space-between" align="middle">
                <Col :span="12">
                    <div class="col-item" @click="gotoPage('roleManage')">
                        <img class="col-item-img" src="../../assets/images/icon-role.png">
                        <div class="col-item-info">
                            <p class="col-item-name">角色管理</p>
                            <p class="col-item-count">{{info.roleNum||0}}</p>
                        </div>
                    </div>
                </Col>
                <Col :span="12">
                    <div class="col-item" @click="gotoPage('empManage')">
                        <img class="col-item-img" src="../../assets/images/icon-people.png">
                        <div class="col-item-info">
                            <p class="col-item-name">员工管理</p>
                            <p class="col-item-count">{{info.empNum||0}}</p>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row class="row-button" type="flex" justify="space-between" align="middle">
                <Col :span="12" class="col-item"><Button class="col-item-bt" @click="gotoPage('roleAdd', 'roleAdd')">新建角色</Button></Col>
                <Col :span="12" class="col-item"><Button class="col-item-bt" @click="gotoPage('empAdd', 'add')">新建员工</Button></Col>
            </Row>
        </div>
        <div class='account-tip'>
            <div class="account-tip-inner">
            <p>1、角色管理</p>
            <p>设置角色对应的权限，则该角色的所有员工账号即可获得此权限。未设置角色信息的员工账号，无法操作商家工作台任何功能</p>
            <p class="pd">2、员工管理</p>
            <p>员工支持新建、修改，给相应的员工挂对应的角色，员工绑定的手机号做为登录账号</p>
            </div>
        </div>
    </Frame>
</template>
<script>
import Frame from '@components/commonFramework/index'
import Head from '@components/title'
import { Button, Row, Col } from 'ant-design-vue'

export default {
    data() {
        return {
            info: {}
        }
    },
    async created() {
        const json = await this.$store.dispatch('account/getList')
        this.info = json || {}
    },
    methods: {
        gotoPage(name, type){
            this.$router.push({
                name,
                params:{type}
            })
        }
    },
    components: {
        Frame,
        Head,
        Button,
        Row, Col
    }
}
</script>
<style lang="scss" scoped>
.account-content{
    padding-left: 150px;
    padding-right: 150px;
    .col-item{
        display:flex;
        align-items: center;
        justify-content: center;
    }
    .col-item-img{
        width: 60px;
        height: 60px;
    }
    .col-item-info{
       padding-left: 8px;
       
        .col-item-name{
            font-size: 14px;
            color: #333333;
        }
        .col-item-count{
            font-size: 24px;
            color: #333333;
        }
    }
    .row-button{
        padding-top:30px;
    }
    .col-item-bt{
        background: #F7F7F7;
        border: 1px solid #DBDBDB;
        border-radius: 4px;
        line-height: 44px;
        height: 44px;
        width:130px;
        font-size: 14px;
        color: #333333;
        // text-align: center;
    }
}
.account-tip{
    padding-top:60px;
    font-size: 13px;
    color:#666;
    display: flex;
    align-items: center;
    justify-content: center;

    .account-tip-inner{
        width: 720px;

        .pd{
            padding-top: 20px;
        }
    }
}
</style>
